module.exports = __webpack_public_path__ + "15efa2c623523e2aaa0b004b94bca346.MP3";